<template>
    <Dialog v-model:open="opnened">
        <DialogTrigger> <slot /> </DialogTrigger>
        <DialogContent>
            <DialogHeader>
                <DialogTitle>
                    {{ $t("event_types.create_event_type.title") }}</DialogTitle
                >
                <!-- <DialogDescription>
                    Make changes to your profile here. Click save when you're
                    done.
                </DialogDescription> -->
            </DialogHeader>

            <div class="sm:flex sm:items-start">
                <div class="mt-3 w-full text-center sm:mt-0 sm:text-left">
                    <div class="mt-2">
                        <div v-if="teams.length > 1" class="mt-4">
                            <label
                                for="teamName"
                                class="block text-sm font-medium text-iron-700"
                            >
                                {{
                                    $t(
                                        "event_types.create_event_type.team_label",
                                    )
                                }}
                            </label>
                            <div class="mt-1 flex w-full justify-end">
                                <select
                                    id="teamName"
                                    v-model="teamId"
                                    class="focus-visible:ring-iron-950 dark:bg-iron-950 dark:ring-offset-iron-950 flex h-10 w-full rounded-lg border border-iron-200 bg-white px-3 py-2 text-sm ring-offset-white file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-iron-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 dark:border-iron-800 dark:placeholder:text-iron-400 dark:focus-visible:ring-iron-300"
                                >
                                    <option
                                        v-for="team in teams"
                                        :key="team.id"
                                        :value="team.id"
                                    >
                                        {{
                                            team.personal_team
                                                ? $t("event_types.personal")
                                                : team.name
                                        }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="mt-4">
                            <label
                                for="email"
                                class="block text-sm font-medium text-iron-700"
                            >
                                {{
                                    $t(
                                        "event_types.create_event_type.name_label",
                                    )
                                }}
                            </label>
                            <div class="mt-1 w-full">
                                <Input
                                    v-model="eventTypeName"
                                    type="text"
                                    name="event-type-name"
                                    :placeholder="
                                        $t(
                                            'event_types.create_event_type.name_placeholder',
                                        )
                                    "
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <DialogFooter>
                <div
                    class="inline-block transform overflow-hidden rounded-lg text-left align-bottom transition-all sm:w-full sm:max-w-lg sm:align-middle"
                >
                    <div
                        class="gap-3 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6"
                    >
                        <Button @click="createEventType">{{
                            $t("event_types.create_event_type.new_event_type")
                        }}</Button>

                        <Button variant="outline" @click="closeModal">
                            {{ $t("cancel") }}</Button
                        >
                    </div>
                </div>
            </DialogFooter>
        </DialogContent>
    </Dialog>
</template>

<script setup lang="ts">
import { router, usePage } from "@inertiajs/vue3";
import { computed, ref } from "vue";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import route from "ziggy-js";

const props = defineProps<{
    integrations: any[];
}>();

const page = usePage();

const eventTypeName = ref("");
const opnened = ref(false);
// @ts-expect-error
const teamId = ref<any>(page.props.personalTeam.id);

function closeModal() {
    opnened.value = false;
}

async function createEventType() {
    try {

        const data = {
            name: eventTypeName.value,
            enabled: true,
            description: "testdfsfs",
        };

        data.team_id = teamId.value;

        await router.post("/event-types", data, {
            onSuccess: () => {
                closeModal();
            },
            preserveScroll: true,
        });
    } catch (err) {
        console.error(err);
    }
}

const teams = computed(() => {
    return page.props.allTeams;
});
</script>

<style></style>
